module.exports = __webpack_public_path__ + "media/images/cureus_logo_white-8b5fdddf1abb29ed3855ecccc7afbcbe.png";